import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeConfirmPage from '@/views/home-confirm/index.vue'
import FeedbackPage from '@/views/feedback/index.vue'
import MessageBoardPage from '@/views/message-board/index.vue'
import MyOrdersPage from '@/views/my-orders/index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home-confirm',
    component: HomeConfirmPage
  },
  {
    path: '/my-orders',
    name: 'my-orders',
    component: MyOrdersPage
  },
  {
    path: '/feedback',
    name: 'feedback',
    component: FeedbackPage
  },
  {
    path: '/message-board',
    name: 'message-board',
    component: MessageBoardPage
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
